/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/DailyChallengeMainMenuTile',['pixi', 'absolute', 'lodash', 'Solitaire/SolitaireGameMode', 'MenuUI/MenuTile',
		'MenuUI/DailyChallengeProgressMeter', 'Solitaire/MvvmStructure/Service/SolitaireDailyChallengeService',
		'util/NineSliceWrapper', 'MenuUI/DropShadow'],

	function (PIXI, Absolute, _, SolitaireGameMode, MenuTile, DailyChallengeProgressMeter,
	          SolitaireDailyChallengeService, NineSliceWrapper, DropShadow) {

		var DailyChallengeMainMenuTile = function (config, game) {
			var defaultConfig = {};
			this.initDailyChallengeMainMenuTile(_.extend(defaultConfig, config), game);
		};

		DailyChallengeMainMenuTile.prototype = Object.create(MenuTile.prototype);

		DailyChallengeMainMenuTile.prototype.initDailyChallengeMainMenuTile = function (config, game) {

			this.game = game;

			MenuTile.call(this, config);

			var today = new Date(),
				monthCenterX = Absolute.Coords.x(120),
				monthLetterStyle = {
					font: 'Bold ' + Absolute.ScreenMetrics.getResScale() * 28 + 'px Arial',
					tint: 0x000001,
					fill: '#000001',
					fontWeight: '400',
					fontFamily: 'segoe',
					align: 'left'
				},
				months = Absolute.StringManager('months', null, true),
				monthLabel = new PIXI.Text(months[today.getMonth()].toUpperCase(), monthLetterStyle),
				dayCenterX = Absolute.Coords.x(115),
				dayLetterStyle = {
					font: Absolute.ScreenMetrics.getResScale() * 130 + 'px Arial',
					tint: 0x000001,
					fill: '#000001',
					fontFamily: 'segoe',
					align: 'left'
				},
				dayLabel = new PIXI.Text(today.getDate().toString(), dayLetterStyle),
				sticker = PIXI.Sprite.fromFrame(config.sticker);
			sticker.position.set(
				Absolute.Coords.x(20),
				Absolute.Coords.y(7)
			);
			sticker.scale.set(0.9, 0.9);

			monthLabel.x = monthCenterX - monthLabel.width / 2;
			monthLabel.y = Absolute.Coords.y(53);
			dayLabel.x = dayCenterX - dayLabel.width / 2 + Absolute.Coords.x(10);
			dayLabel.y = Absolute.Coords.y(65);

			monthLabel.rotation = -Math.PI / 20;
			dayLabel.rotation = -Math.PI / 20;

			this.sticker = sticker;
			this.dayLabel = dayLabel;
			this.monthLabel = monthLabel;

			this.buildHeader();

			this.addChild(sticker);
			this.addChild(monthLabel);
			this.addChild(dayLabel);

			this.buildHoverGraphic();
			this.initImageOutline();
			this.positionTile();
			this.buildDropShadow();
		};

		DailyChallengeMainMenuTile.prototype.buildHeader = function () {
			this.initHeaderBackground();
			this.initHeaderOutline();
			this.initHeaderShadow();
			this.initHeaderText();
			this.initImageShadow();
		};

		DailyChallengeMainMenuTile.prototype.initHeaderBackground = function () {
			var header = new PIXI.Graphics();
			header.beginFill(0x204a8f, 1);
			header.drawRect(0, 0, this.image.width, Absolute.Coords.y(70));
			header.endFill();
			this.addChild(header);
			this.header = header;
		};

		DailyChallengeMainMenuTile.prototype.initHeaderOutline = function () {
			var outLine = new PIXI.Graphics(),
				lineWeight = Absolute.Coords.x(1);
			outLine.beginFill(0xFFFFFF, 0);
			outLine.lineStyle(lineWeight, 0xffffff, 1);
			outLine.moveTo(0, this.header.height);
			outLine.lineTo(this.header.width, this.header.height);
			outLine.endFill();
			this.addChild(outLine);
		};

		DailyChallengeMainMenuTile.prototype.initHeaderShadow = function () {
			var leftShadow = this.buildShadow(
				0, 0, this.header.width / 2, this.header.height, 0
				),
				rightShadow = this.buildShadow(
					this.header.width, this.header.height, this.header.width / 2, this.header.height, Math.PI
				);
			this.addChild(leftShadow);
			this.addChild(rightShadow);
		};

		DailyChallengeMainMenuTile.prototype.initHeaderText = function () {
			var textStyle = {
					font: 'bold ' + Absolute.ScreenMetrics.getResScale() * 40 + "px Arial",
					fontFamily: 'segoeLight',
					fill: '#ffffff',
					align: 'left',
					strokeThickness: 2
				},
				text = new PIXI.Text(Absolute.StringManager('tiles.dailyChallenge').toUpperCase(), textStyle);
			text.anchor.set(0.5, 0.5);
			text.x = this.header.width / 2;
			text.y = this.header.height / 2 + Absolute.Coords.y(5);
			this.addChild(text);
		};

		DailyChallengeMainMenuTile.prototype.initImageShadow = function () {
			var shadowWidth = this.image.width / 8,
				shadowHeight = this.image.height + this.header.height,
				leftShadow = this.buildShadow(0, 0, shadowWidth, shadowHeight, 0),
				rightShadow = this.buildShadow(
					this.image.width, shadowHeight, shadowWidth, shadowHeight, Math.PI
				);
			this.addChild(leftShadow);
			this.addChild(rightShadow);
		}

		DailyChallengeMainMenuTile.prototype.buildShadow = function (x, y, width, height, rotation) {
			var shadow = new NineSliceWrapper(
				'mainmenu/shadow_stretch.png',
				width, height,
				5, 2, 5, 5);
			shadow.position.set(x, y);
			shadow.alpha = 1;
			shadow.rotation = rotation;
			return shadow;
		};

		DailyChallengeMainMenuTile.prototype.buildHoverGraphic = function () {
			var hoverGraphic = new PIXI.Graphics(),
				lineWeight = Absolute.Coords.x(4);
			hoverGraphic.beginFill(0xFFFFFF, 0);
			hoverGraphic.lineStyle(lineWeight, 0xFFFFFF, 1);
			hoverGraphic.drawRect(0, 0, this.header.width, this.header.height + this.image.height);
			hoverGraphic.endFill();
			this.hover = hoverGraphic;
			this.hover.alpha = 0.01;
			this.addChild(this.hover)
		};

		DailyChallengeMainMenuTile.prototype.initImageOutline = function () {
			var outLine = new PIXI.Graphics(),
				lineWeight = Absolute.Coords.x(1);
			outLine.beginFill(0xFFFFFF, 0);
			outLine.lineStyle(lineWeight, 0xffffff, 1);
			outLine.drawRect(0, 0, this.image.width, this.image.height + this.header.height);
			outLine.endFill();
			this.addChild(outLine);
			this.imageOutline = outLine;
		};

		DailyChallengeMainMenuTile.prototype.positionTile = function () {
			this.image.y = this.header.y + this.header.height;
			this.sticker.y = this.image.y + Absolute.Coords.y(10);
			this.monthLabel.y = this.sticker.y + Absolute.Coords.y(45);
			this.dayLabel.y = this.monthLabel.y + Absolute.Coords.y(20);
		};

		DailyChallengeMainMenuTile.prototype.buildDropShadow = function () {
			if (this.dropShadow) this.removeChild(this.dropShadow);
			this.dropShadow = new DropShadow({
				baseWidth: this.image.width,
				baseHeight: this.image.height + this.header.height
			});
			this.addChildAt(this.dropShadow, 0);
		};

		DailyChallengeMainMenuTile.prototype.updateStats = function () {

			SolitaireDailyChallengeService.GetChallengeSettingsForCurrentMonth(
				function (monthSettings) {
				}.bind(this),
				function () {
					Absolute.Debug.log("Error: GetChallengeSettingsForCurrentMonth()");
				}
			);
		};

		DailyChallengeMainMenuTile.prototype.onShow = function () {

			this.interactive = true;

			if (SolitaireDailyChallengeService.HasCache() && SolitaireDailyChallengeService.IsValid()) {
				this.updateStats();
			}

		};

		return DailyChallengeMainMenuTile;

	});

